import Tabs from 'antd/es/tabs';
import styled, { css } from 'styled-components';
import { media } from '../../../theme/mixins/responsive';
const ContainerStyling = css `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.appearance.spacing * 3}px;
  background: ${({ theme }) => theme.colors.white_2};
`;
const getInlinePadding = (theme) => {
    return css `
    padding-inline: ${theme.spacing.md}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
      padding-inline: ${theme.spacing.lg}px;
    }

    @media (min-width: 1600px) {
      padding-inline: ${theme.spacing.lg}px;
    }
  `;
};
const getBlockPadding = (theme) => {
    return css `
    padding-block: ${theme.spacing.sm}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
      padding-block: ${theme.spacing.md}px;
    }

    @media (min-width: 1600px) {
      padding-block: ${theme.spacing.md}px;
    }
  `;
};
const ContainerSizeStyling = css `
  width: 100%;
`;
export const ContainerTabsStyled = styled(Tabs) `
  .ant-tabs-nav {
    margin: ${({ theme }) => `${theme.spacing.xs}px`};
    ${({ $fullWidth }) => (!$fullWidth ? ContainerSizeStyling : undefined)}
    .ant-tabs-tab {
      background: ${({ theme }) => theme.colors.beige_1};
      border: 1px solid ${({ theme }) => theme.colors.grey_5};
      border-bottom: none;
      &.ant-tabs-tab-active {
        background: ${({ theme }) => theme.colors.white_2};
      }
    }
  }
  .ant-tabs-content {
    ${({ $fullWidth }) => (!$fullWidth ? ContainerSizeStyling : undefined)}
    ${ContainerStyling}
    padding: ${({ theme }) => `${theme.spacing.md}px`} 24px;

    border: 1px solid ${({ theme }) => theme.colors.grey_5};
    ${({ $style }) => css(Object.assign({}, $style))}

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
      padding: ${({ theme }) => `${theme.spacing.md}px`} 52px;
      ${({ $style }) => css(Object.assign({}, $style))}
    }
  }
`;
export const ContainerStyled = styled.section `
  ${({ $fullWidth }) => (!$fullWidth ? ContainerSizeStyling : undefined)}
  ${ContainerStyling}

  overflow: ${({ $overflow }) => $overflow !== null && $overflow !== void 0 ? $overflow : 'hidden'};
`;
export const ContainerWrapperStyled = styled.div `
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  display: flex;
  flex-direction: column;
  overflow: ${({ $overflow }) => $overflow !== null && $overflow !== void 0 ? $overflow : 'hidden'};
  ${ContainerStyled} {
    height: 100%;
  }
  ${({ $noPadding, theme }) => !$noPadding &&
    css `
      ${ContainerStyled} {
        ${getBlockPadding(theme)};
        ${getInlinePadding(theme)};
      }
      ${ContainerHeaderStyled} ,${ContainerFooterStyled} {
        padding-block: ${theme.spacing.sm}px;
        ${getInlinePadding(theme)};
      }
    `}
`;
export const ContainerFullWidthHeaderStyling = styled.div `
  position: sticky;
  top: -1px;
  z-index: 1000;

  width: calc(100% + 24px + 24px);
  margin-left: -24px;
  padding: ${({ theme }) => `${theme.spacing.xs}px`} 24px;

  &.is-pinned {
    backdrop-filter: blur(5px);
    padding: ${({ theme }) => `${theme.spacing.sm}px`} 24px;
    transition: background-color 200ms linear;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    width: calc(100% + 52px + 52px);
    margin-left: -52px;
    padding: ${({ theme }) => `${theme.spacing.xs}px`} 52px;
    &.is-pinned {
      padding: ${({ theme }) => `${theme.spacing.sm}px`} 52px;
    }
  }
`;
export const ContainerHeaderStyled = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
  background: ${({ theme }) => theme.colors.white_2};

  ${media.tablet `
    gap: ${({ theme }) => theme.spacing.sm}px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  `}
`;
export const ContainerFooterStyled = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.md}px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey_4};
  background: ${({ theme }) => theme.colors.white_2};
`;
